module.exports = __webpack_public_path__ + "static/media/sk.53aae0c1.svg";